export default {
      id: "tick-usage",
      viewBox: "0 0 18 15",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#tick",
      toString: function () {
        return this.url;
      }
    }